import { render } from "./OpportunityDetailCard.vue?vue&type=template&id=6a10948a"
import script from "./OpportunityDetailCard.vue?vue&type=script&lang=js"
export * from "./OpportunityDetailCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__